import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import props from './attrs/props'

export default {
  name: 'ProfessionalFeedback',
  data,
  methods,
  mounted,
  props
}
